import PropTypes from "prop-types"
import React from "react"

class MinNightRequirementWarning extends React.Component {
  render() {
    return (
      <div className="flex items-center gap-4 rounded border border-l-4 border-orange-700 bg-yellow-100 p-4">
        <i
          className="fa-solid fa-circle-exclamation font-semibold text-orange-700"
          aria-hidden="true"
        />
        <span className="text-sm">
          The date(s) selected reflect a {this.props.numberOfNights}-night
          minimum rate. You may book for less than {this.props.numberOfNights}{" "}
          nights, but you will be charged for the minimum nights.
        </span>
      </div>
    )
  }
}

MinNightRequirementWarning.propTypes = {
  numberOfNights: PropTypes.number.isRequired,
}

export default MinNightRequirementWarning
